
export const swrLoadOnce = {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
};
